export enum OperatorQueryKeys {
	GetMemberList = 'operator.getMemberList',
	GetMemberGroup = 'operator.getMemberGroup',
	GetMemberLoginHistory = 'operator.getMemberLoginHistory',
	GetAllPermissions = 'operator.getAllPermissions',
	GetGroupById = 'operator.getGroupById',
	GetMemberById = 'operator.getMemberById',
	GetMemberEventLog = 'operator.getMemberEventLog',
}

export enum OperatorMutationKeys {
	CreateGroup = 'operator.createGroup',
	UpdateGroup = 'operator.updateGroup',
	CreateMember = 'operator.createMember',
	UpdateMember = 'operator.updateMember',
	DeleteMember = 'operator.deleteMember',
	DeleteGroup = 'operator.deleteGroup',
	ExportEventLogCsv = 'operator.exportEventLogCsv',
}
